import {
  MultiSelectFilter,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import { getFilterValueCount } from "../../utils/filter/filtervalue";
import { FilterAccordionItem } from "./FilterAccordionItem";
import { MultiSelectListView } from "../SelectListView/MultiSelectListView";

interface AccordionMultiSelectProps {
  filter: MultiSelectFilter;
  selected: StringArrayFilterValue;
  onChange: (option: SelectOption, isSelected: boolean) => void;
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
}

export const AccordionMultiSelect = ({
  filter,
  selected,
  onChange,
  open,
  onOpenChange,
}: AccordionMultiSelectProps) => {
  const { title } = filter;
  const filterValueCount = getFilterValueCount(filter, [selected]);
  return (
    <FilterAccordionItem
      filter={filter}
      open={!!open}
      onOpenChange={onOpenChange}
      title={filterValueCount ? `${title} (${filterValueCount})` : title}
    >
      <MultiSelectListView
        prefix="accordion"
        filter={filter}
        selected={selected}
        onChange={onChange}
      />
    </FilterAccordionItem>
  );
};
